<template>
  <div class="col-start-1 col-end-13">
    <div class="flex items-center my-2">
      <div
        class="relative text-sm py-2 px-4 shadow text-gray-800 border-l-4 border-green-500 bg-gray-200"
      >
        <p v-html="context.body" v-linkified class="whitespace-pre-wrap"></p>

        <div v-if="context.attachments">
          <AttachmentItem
            v-for="(attachment, index) of context.attachments"
            :key="index"
            :attachment="attachment"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentItem from "./AttachmentItem";

export default {
  components: {
    AttachmentItem
  },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
